// src/components/AnalyticsTracker.tsx

import {
  useEffect,
  useRef,
} from "react";

import {
  useLocation,
} from "react-router-dom";

import {
  ensureAnalyticsSession,
  trackAnalyticsEvent,
} from "../services/analytics";


// =====================================================
// ANALYTICS TRACKER
// =====================================================

const AnalyticsTracker = () => {

  const location =
    useLocation();

  const previousPath =
    useRef<string | null>(
      null
    );


  // ===================================================
  // START VISITOR SESSION
  // ===================================================

  useEffect(() => {

    void ensureAnalyticsSession();

  }, []);


  // ===================================================
  // PAGE VIEWS
  // ===================================================

  useEffect(() => {

    const pagePath =
      `${location.pathname}${location.search}`;

    /*
      Avoid duplicate page_view events caused by
      component re-renders.
    */

    if (
      previousPath.current ===
      pagePath
    ) {
      return;
    }

    previousPath.current =
      pagePath;

    void trackAnalyticsEvent(
      "page_view",
      {
        pagePath,
      }
    );

  }, [
    location.pathname,
    location.search,
  ]);


  return null;
};


export default AnalyticsTracker;
